var url = "//search.bulbamerica.com/projector/getData.php";

function getParameterByName(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(location.search);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}

function setData(data, select_id){
     var toAppend = '';
     var select = '';
     if(select_id == "manufacturer")
         toAppend += '<option value="">Manufacturer</option>';
     else if(select_id == "model")
         toAppend += '<option value="">Model</option>';
     else if(select_id == "product"){
         toAppend += "<div class='collection-wrap clearfix'>" +
                        "<div class='collection-main'>" +
                           "<ul class='block-grid collection-th columns5'>";
     }
    $.each(data,function(i,o){
        if(i != 0){
            if(select_id != "product"){
                if(getParameterByName(select_id) == o.value){
                    select = 'selected= "selected"';
                }else{
                    select = '';
                    if(select_id == "type")
                    {
                        if(data.length == 2){
                            select = 'selected= "selected"';
                        }
                    }
                }
                toAppend += '<option value ="' + o.id + '"' + select +'>'+o.value+'</option>';
            }
            else
            {
                toAppend += 
                "<li>" +
                    "<a class='prod-th show-quick' href='" + o.link + "' title='" + o.name + "' style='height: 353px;'>" +
                        "<span class='thumbnail'>" +
                            "<img src='" + o.image_link + "' alt='" + o.name + "'>" +
                            "<span class='quick-view' data-prdid='#prod-" + o.id + "' style='display: none;'>QUICK VIEW</span>" +
                        "</span>" +
                        "<span class='product-title'>" + o.name + "</span>" +
                        "<span><b>SKU:</b> " + o.sku + "</span>";
                if(o.quantity > 0){
                    toAppend += "<span class='price'><em><del>$ "+ o.compare_at_price + "</del> $" + o.price + "</em></span>";
                }else{
                    toAppend += "<span class='price sold-out'><em>OUT OF STOCK</em></span>"
                }
                //        "{{#on_sale}}<span class='sale round'><i>SALE</i></span>{{/on_sale}}" +
                toAppend += "</a>" +
                    "<div id='prod-" + o.id + "' class='white-popup mfp-hide clearfix'>" +
                        "<div class='product-images clearfix'>" +
                            "<span class='main-image'>" +
                                "<img src='" + o.image_link + "' alt='" + o.name + "'>" +
                //               "{{#on_sale}}<span class='sale round'><i>SALE</i></span>{{/on_sale}}" +
                            "</span>" +
                        "</div>" +
                        "<div class='product-details'>" +
                        "<h1>" + o.name + "</h1>" +
                        "<b>Item SKU:</b> " + o.sku +
                        "<div class='product-price-wrap'>" +
                            "<span class='product-price on-sale'>$ " + o.price + "</span>&nbsp;<s class='product-compare-price'>$ " + o.compare_at_price + "</s>" +
                        "</div>";
                if(o.quantity > 0){
                    toAppend += "<form action='/cart/add' method='post' class='cartableProduct single-var'>" +
                                "<div class='product-variants'>" +
                                    "<fieldset>" +
                                        "<input type='hidden' name='id' value='" + o.variant_id + "'>" +
                                    "</fieldset>" +
                                    "<div class='var-msg'></div>" +
                                "</div>  " +
                                "<div class='quick-actions clearfix'>" +
                                    "<p class='qty-field'>" +
                                        "<label for='product-quantity-" + o.id + "'>Qty:</label>" +
                                        "<input type='number' id='product-quantity-" + o.id + "' name='quantity' value='1' min='1'>" +
                                    "</p>" +
                                    "<div id='inventory' style='float: left; font-weight: bold; font-size: 1em; text-align: center; padding-top: 15px;'>" + o.quantity + " in stock</div>" +
                                    "<input type='submit' class='add-to-cart' class='btn' name='add' value='Add to cart'>" +
                                 "</div>" +
                            "</form>";
                }else{
                    toAppend += "<p style='color: #F70023'><strong>Sorry, this product is temporarily out of stock.</strong></p>";
                }
                toAppend += "<div class='product-description rte'>" + o.description + "</div>" +
                                "<a href='" + o.link + "'><strong>» View full product details</strong></a>" +
                                "<br> <br>" +
                            "</div>" +
                    "</div>" +
                "</li>";
            }
        }
    });
    if(select_id != "product"){
        $("#" + select_id).empty().append(toAppend);
        $("#" + select_id).prop("disabled", false);
        $("#projector"+ select_id).css("display", "table-cell");
      	if($(document).width() < 500)
            var width = $(document).width() * 24 / 100;
        else
      		var width = $(document).width() * 12 / 100;
      	$("#" + select_id).width(width);
      	$("#" + select_id).chosen();
    }
    else{    
        toAppend += "</ul></div></div>";
        $("#" + select_id).html(toAppend);
        $("#productHeader").html("Your Results:");
        bindQuickView();
    }
    
}

function valueChanged(action, num){
    var sendrequest = false;
    var queryParameters = {}, queryString = location.search.substring(1), re = /([^&=]+)=([^&]*)/g, m;

    while (m = re.exec(queryString)) {
        queryParameters[decodeURIComponent(m[1])] = decodeURIComponent(m[2]);
    }

    queryParameters['manufacturer'] = "";
    queryParameters['model'] = "";

    if($("#manufacturer").val() && num >= 1)
        queryParameters['manufacturer'] = $("#manufacturer option:selected").text();

    if($("#model").val() && num >= 2)
        queryParameters['model'] = $("#model option:selected").text();


    queryParameters['action'] = action;
    if(queryParameters['action'] == "")
        queryParameters['action'] = "getmanufacturer";

    var manufacturer = $("#manufacturer").val();
    var model = $("#model").val();

    if(action == "getmanufacturer")
        sendrequest = true;
    else if(action == "getmodel" && manufacturer)
        sendrequest = true;
  	else if(action == "getproduct" && manufacturer && model)
        sendrequest = true;

    if(sendrequest)
        location.search = $.param(queryParameters); // Causes page to reload
}

function getID(field, value){
    var projector_data = JSON.parse(localStorage.getItem("projector_data"));
    $.each(projector_data[field],function(i,o){
        if(o.value == value){
                val = o.id;    
        }
    });
    return val;
}

function pageReady(){
    var manufacturer = getParameterByName("manufacturer");
    var model = getParameterByName("model");
    var action = getParameterByName("action");
    
    var manufacturer_id = "", model_id = "";
    
    if(localStorage.projector_data){
        if(manufacturer)
            manufacturer_id = getID("manufacturer", manufacturer);
        if(model)
            model_id = getID("model", model);
    }
    if(action == "")
        action = "getmanufacturer";
   
    $.ajax({
     type: "POST",
     url: url,
     async: false,
     data: {manufacturer: manufacturer, manufacturer_id: manufacturer_id,
            model: model, model_id: model_id,
            action: action},
     dataType: "json",
     success: function(data){
        if(typeof(Storage) !== "undefined") {
            var projector_data = JSON.parse(localStorage.getItem("projector_data"));
          if(projector_data){
       	if(action == "getmanufacturer"){
          projector_data['manufacturer'] = [];
          projector_data['model'] = [];
          projector_data['product'] = [];
        }
         if(action == "getmodel"){
          projector_data['model'] = [];
          projector_data['product'] = [];
         }
         if(action == "getproduct"){
          projector_data['product'] = [];
         }
       }
            if(projector_data){
                merged_data = $.extend({}, projector_data, data);
                localStorage.setItem("projector_data", JSON.stringify(merged_data));
            }
            else{
                localStorage.setItem("projector_data", JSON.stringify(data));
            }
            
        } else {
            // Sorry! No Web Storage support..
        }
        projector_data = JSON.parse(localStorage.getItem("projector_data"));
       
        if(projector_data['manufacturer'].length > 1){
            setData(projector_data['manufacturer'], "manufacturer");
            if(action == "getmodel"){
                if(projector_data['model']){
                    setData(projector_data['model'], "model");
                    $("#model").prop("disabled", false);
                }else{
                    toAppend = "<b>No Model available for the above selection.</b>";
                    $("#message").html(toAppend);
                }
            }else if(action == "getproduct"){
                setData(projector_data['model'], "model");
                $("#model").prop("disabled", false);
                if(projector_data['product'].length > 1){
                    setData(projector_data['product'], 'product');
                }else{
                    toAppend = "<b>No Product available for the above selection.</b>";
                    $("#message").html(toAppend);
                }
            }
        }
    }
});
}